// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".setting-description[data-v-9e28f242] {\n  white-space: pre-line;\n  padding-bottom: 16px;\n}\n.setting-description.pc-mode[data-v-9e28f242] {\n    padding: 16px 0;\n}\n#sort-comment-setting #sort-comment-setting-group.pc-mode[data-v-9e28f242] {\n  padding: 1rem;\n  background-color: whitesmoke !important;\n}\n#sort-comment-setting #sort-comment-setting-group.mobile-mode[data-v-9e28f242] {\n  min-height: 75vh;\n}\n", ""]);
// Exports
module.exports = exports;
